import { get } from 'lodash';

export const getJsonField = <FieldType>(
  json: unknown,
  path: string,
  typeAssertion?: (fieldValue: unknown) => boolean
): FieldType | null => {
  const fieldValue = get(json, path);
  if (fieldValue === undefined) return null;
  if (typeAssertion && !typeAssertion(fieldValue)) return null;

  return fieldValue;
};
